import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { Widget, WidgetEmptyState } from '@factorialco/f0-react/dist/experimental'
import { SoftwareManagementSoftwareSetupItemFragment } from 'generated/resources/graphql'
import moment from 'moment'

import Date from 'modules/core/components/Date'
import { dateBackendToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

type DetailsWidgetProps = {
  softwareSetup: SoftwareManagementSoftwareSetupItemFragment
  onEdit: () => void
}

const DetailsWidget = ({ softwareSetup, onEdit }: DetailsWidgetProps) => {
  const currentDate = moment().startOf('day')
  const renewalDate = moment(softwareSetup.renewalDate).startOf('day')
  const daysLeft = renewalDate.diff(currentDate, 'days')

  const title = i18n.t('software_management.software_setups.details.title')

  return (
    <Widget
      header={{
        title,
        link: {
          title,
          onClick: onEdit,
        },
      }}
      action={{ label: title, onClick: onEdit }}
    >
      {softwareSetup.renewalDate ? (
        <Box
          paddingX="s16"
          paddingY="s12"
          alignItems="center"
          justifyContent="spaceBetween"
          flexDirection="row"
        >
          <Text.Normal color="grey1000">
            {i18n.t('software_management.software_setups.details.fields.renewal_date')}
          </Text.Normal>

          <Box flexDirection="row" alignItems="center" gap="s16">
            {daysLeft > 0 ? (
              <Box>
                <Text size="200" weight="medium" color="grey1000">
                  {dateBackendToUI(softwareSetup.renewalDate)}
                </Text>
                <Text size="200" weight="normal">
                  {i18n.tp('payroll_onboarding.navigator.tags.due_on_in', {
                    count: daysLeft,
                  })}
                </Text>
              </Box>
            ) : (
              <Tag leftItem="circle" type="radical" showCircle>
                {i18n.t('common.expired')}
              </Tag>
            )}

            <Date date={renewalDate} />
          </Box>
        </Box>
      ) : (
        <WidgetEmptyState
          title={i18n.t('software_management.software_setups.details.blank.message')}
          description="-"
          emoji="📆"
          actions={[
            {
              label: i18n.t('software_management.software_setups.details.blank.cta'),
              onClick: onEdit,
            },
          ]}
        />
      )}
    </Widget>
  )
}

export default DetailsWidget
